import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';

import { LoaderContainer } from './TabContent.styled';

const COPIES = strings.sendoutsV2.drawers.sendoutInterviewDetails;

export const TabContent = ({
  hasLoadError,
  isEditMode,
  isFetching,
  isFormPreloaded,
  isRecordMissing,
  presentation,
  record
}) => {
  if (isFetching) {
    return (
      <LoaderContainer>
        <CircularProgress />
      </LoaderContainer>
    );
  }

  if (hasLoadError) return <EmptyPlaceholder title={COPIES.error} />;

  if (!isEditMode && isRecordMissing && presentation.emptyCallMessage) {
    return <EmptyPlaceholder title={presentation.emptyCallMessage} />;
  }

  if (!isEditMode) return presentation.renderReadOnly(record);

  return <When condition={isFormPreloaded || isRecordMissing}>{presentation.formContent}</When>;
};
